import { useLocation } from 'react-router-dom';
import schedule from '../../../assets/img/leadsform/schedule.svg';
import { Form, Formik } from 'formik';
import { TextArea, TextBox } from '../../../shared/controls/form';
import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import apiServices from '../../../services/service';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from '../../../redux/selector';
import CreatableSelect from 'react-select/creatable';
import { fetchEmailAndAppendToModule } from '../../../redux/actions';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import SelectTemplate from '../../leads/selectTemplate';
import EmailEditor from 'react-email-editor';
import Editor from 'react-simple-wysiwyg';
import DateTimePicker from '../../../shared/controls/form/dateTimePicker';
import template from '../../../assets/img/crm_home/main-content/template.png';
import reset from '../../../assets/img/crm_home/main-content/reset.png';

const ComposeEmail = ({ localData, module, handleClose, handleChange }) => {
  const [formData, setFormData] = useState([]);
  const [formEdited, setFormEdited] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedToEmails, setSelectedToEmails] = useState(
    localData.toAddress ? localData.toAddress : []
  );
  const [selectedCcEmail, setSelectedCcEmail] = useState(null);
  const [selectedBccEmail, setSelectedBccEmail] = useState(null);
  const [selectedFromEmail, setSelectedFromEmail] = useState(null);
  const userInfo = useSelector(getUser);
  const userName = userInfo.user.display_name;
  const userEmailId = userInfo.user.email;
  const dispatch = useDispatch();
  const [popupVisible, setPopupVisible] = useState(false);
  const [scheduleTime, setScheduleTime] = useState('');
  const [templatePopup, setTemplatePopup] = useState(false);
  const [preview, setPreview] = useState(false);
  const emailEditorRef = useRef(null);
  const location = useLocation();
  const [designJson, setDesignJson] = useState('');
  const [contentHtml, setContentHtml] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [isSendDisabled, setIsSendDisabled] = useState(true);

  const [showCcMail, setShowCcMail] = useState(false);
  const [showBccMail, setShowBccMail] = useState(false);
  const emailString = process.env.REACT_APP_FROM_ADDRESSES || '';
  const emailList = emailString.split(',').filter((email) => email.trim() !== '');
  const fromAddressOptions = emailList.map((email) => ({ value: email, label: email }));

  useEffect(() => {
    if (localData && localData.type === 'preview') {
      const updatedFormData = {
        ...formData,
        subject: localData.subject,
        toAddress: localData.toAddress,
        message: localData.message,
        fromAddress: localData.fromAddress,
        ccAddress: localData.ccAddress,
        bccAddress: localData.bccAddress,
      };
      setFormData(updatedFormData);
      if (updatedFormData?.message?.includes('<!DOC')) {
        setPreview(true);
      } else {
        setPreview(false);
      }
      setDesignJson(localData.contentJson);
    }
  }, []);

  useEffect(() => {
    // Disable button if 'fromAddress' or 'toAddress' is missing or empty
    setIsSendDisabled((!formData.fromAddress || !formData.toAddress?.length) && !scheduleTime);
  }, [formData.fromAddress, formData.toAddress, scheduleTime]); // Runs when either changes

  const handleOpenTemplatePopup = () => {
    setTemplatePopup(true);
  };

  const handleCloseTemplatePopup = () => {
    setTemplatePopup(false);
  };

  const handleDone = () => {
    setPopupVisible(false);
    // Combine date and time into a single field if both are selected
    if (scheduleTime) {
      const combinedDateTime = `${scheduleTime}`;
      // Update formData with the scheduled date and time
      setFormData((prev) => ({
        ...prev,
        toAddress: prev?.toAddress, // Set initial form data
      }));
    }
  };

  const handleToggle = () => {
    if (!popupVisible) {
      setPopupVisible(true);
    }
  };

  const handleCancel = () => {
    setPopupVisible(false);
  };

  const customStyles = {
    control: (base, state) => ({
      ...base,
      border: state.isFocused ? '2px solid transparent' : '1px solid transparent',
      borderRadius: '5px',
      boxShadow: state.isFocused ? 'none' : 'none',
      ':hover': {
        borderColor: 'transparent',
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: '#888',
      fontSize: '.8rem',
    }),

    menu: (base) => ({
      ...base,
      minWidth: '250px',
      width: '250px',
    }),
    menuList: (base) => ({
      ...base,
      minWidth: '250px',
      width: '250px',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      display: 'none', // Hide the dropdown arrow
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: '#E7F2FF',
      borderRadius: '50px',
      padding: '5px 14px',
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: '#707070',
      fontSize: '.8rem',
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: '#4caf50',
      ':hover': {
        backgroundColor: '#d32f2f',
        color: '#fff',
      },
    }),
  };

  const handleChangeForm = (e) => {
    const { name, value } = e.target;
    // Restrict input for specific fields
    let convertedValue = value;

    // Update form data
    setFormData({
      ...formData,
      [name]: convertedValue,
    });

    setFormEdited(true);
  };
  const handleEmailChange = (selectedValue, fieldName) => {
    if (fieldName === 'toAddress') {
      // For multi-select, selectedValue is an array of options
      setSelectedToEmails(selectedValue);
      setFormData((prev) => ({
        ...prev,
        toAddress: selectedValue ? selectedValue.value : '',
      }));
    } else if (fieldName === 'fromAddress') {
      // For single-select, selectedValue is an object (or null)
      setSelectedFromEmail(selectedValue);
      setFormData((prev) => ({
        ...prev,
        fromAddress: selectedValue ? selectedValue.value : '',
      }));
    } else if (fieldName === 'ccAddress') {
      // For multi-select, selectedValue is an array of options
      setSelectedCcEmail(selectedValue);
      const emails = selectedValue.map((option) => option.value);
      setFormData((prev) => ({
        ...prev,
        ccAddress: emails.join('; '),
      }));
    } else if (fieldName === 'bccAddress') {
      // For multi-select, selectedValue is an array of options
      setSelectedBccEmail(selectedValue);
      const emails = selectedValue.map((option) => option.value);
      setFormData((prev) => ({
        ...prev,
        bccAddress: emails.join('; '),
      }));
    }
  };

  useEffect(() => {
    if (localData.email) {
      const emails = localData.email.split(';').map((email) => email.trim());
      const formattedEmails = emails.map((email) => ({
        label: email,
        value: email,
      }));
      setSelectedToEmails(formattedEmails); // Set initial selected emails
      setFormData((prev) => ({
        ...prev,
        toAddress: localData.email, // Set initial form data
      }));
    }
  }, [localData.email]);

  const handleSubmit = (formData) => {
    setLoading(true)
    const preparedFormData = {
      ...formData,
      module: module,
      moduleId: localData.id,
      status: formData.scheduledTime ? 'Scheduled' : 'Pending',
      isDraft: false,
      scheduledTime: formData.scheduledTime ? formData.scheduledTime : null,
      message: formData.message ? formData.message : contentHtml,
      optOut: localData.optOut ? '1' : '0',
    };
    apiServices
      .sendEmail(preparedFormData)
      .then((response) => {
        if (response.status === 200) {
          setLoading(false)
          handleClose();
          toast.success('Email Sent Successfully!', { position: 'top-right' });
          setTimeout(() => {
            dispatch(
              fetchEmailAndAppendToModule({
                moduleName: module,
                id: localData.id,
              })
            );
          }, 2000);
        } else {
          setLoading(false);
          const errorMessages = [];
          for (const key in response.errors) {
            if (response.errors.hasOwnProperty(key)) {
              const messages = response.errors[key];
              errorMessages.push(...messages);
            }
          }
          errorMessages.forEach((errorMessage) => {
            toast.error(errorMessage, { position: 'top-right' });
          });
        }
      })

      .catch((error) => {
        console.error('Error:', error, 'DataFormat:', formData);
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
        });
        setLoading(false);
      });
  };

  const handleCloseWithDraftCheck = () => {
    // Check if formData has any values, ignoring the toAddress field
    const hasFormDataValues = Object.entries(formData).some(
      ([key, value]) => key !== 'toAddress' && value && value.toString().trim() !== ''
    );

    if (hasFormDataValues && localData.type !== 'preview') {
      setShowPopup(true);
    } else {
      // Otherwise, just close the modal
      handleClose();
    }
  };

  const handleCloseDraftPopup = () => {
    setShowPopup(false);
    handleClose();
  };

  const handleSend = () => {
    const updatedFormData = {
      ...formData,
    };

    if (scheduleTime) {
      updatedFormData.scheduledTime = scheduleTime;
    }

    // Submit the form
    handleSubmit(updatedFormData);
  };

  const handleHtml = (data, preview) => {
    setFormData({ ...formData, subject: data[0].subject, templateId: data[0].id });
    setDesignJson(data[0].contentJson);
    setPreview(preview);
  };
  const handleReset = () => {
    setFormData((prevFormData) => ({
      ...prevFormData, // Keep other fields unchanged
      subject: '', // Clear subject
      message: '', // Clear message
    }));

    setDesignJson(''); // Clear template JSON
    setContentHtml(''); // Clear template HTML content
    setPreview(false); // Disable preview mode
  };

  const replacePlaceholders = (design, localData) => {
    // Convert the design to a string to perform replacements
    let designString = JSON.stringify(design);

    // Replace all placeholders with actual data
    for (const key in localData) {
      if (localData.hasOwnProperty(key)) {
        const placeholder = `{{${key}}}`;
        const value = localData[key];
        designString = designString.replace(new RegExp(placeholder, 'g'), value);
      }
    }

    // Convert the string back to an object
    return JSON.parse(designString);
  };
  const onLoad = () => {
    //console.log("Email editor loaded.");
    if (designJson) {
      // Parse the design JSON
      let design = JSON.parse(designJson);

      // Replace placeholders with actual data
      design = replacePlaceholders(design, localData);

      // Load the updated design into the editor
      emailEditorRef.current.editor.loadDesign(design);
      emailEditorRef.current.editor.exportHtml((data) => {
        const { html } = data;
        const cleanedHtml = html.replace(/<o:p>.*?<\/o:p>/g, '');
        // console.log("Exported HTML:", html);
        setContentHtml(cleanedHtml); // Save the HTML in state
      });
      const unlayer = emailEditorRef.current?.editor;
      unlayer?.showPreview('tablet');
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const [isMinimized, setIsMinimized] = useState(false);

  const handleMinimize = () => {
    setIsMinimized(!isMinimized);
  };

  const handleShowCc = () => {
    setShowCcMail(true);
  };

  const handleShowBcc = () => {
    setShowBccMail(true);
  };

  return (
    <>
      <div id="mail_popup">
        <div className={`popup-overlay ${isMinimized ? 'minimized' : ''}`}>
          <div className="popup-content" style={{ zIndex: '990' }}>
            <div className="popup-header border_btm email_hd mail_header">
              <h5>New Message</h5>
              <div className="modal_btn_group">
                {!isMinimized ? (
                  <button className="minimize-btn" onClick={handleMinimize}>
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V8M8 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V16M21 8V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H16M21 16V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H16"
                        stroke="#ffffff"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                ) : (
                  <button className="minimize-btn" onClick={handleMinimize}>
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.99976 8H3.19976C4.87991 8 5.71999 8 6.36173 7.67302C6.92621 7.3854 7.38516 6.92646 7.67278 6.36197C7.99976 5.72024 7.99976 4.88016 7.99976 3.2V3M2.99976 16H3.19976C4.87991 16 5.71999 16 6.36173 16.327C6.92621 16.6146 7.38516 17.0735 7.67278 17.638C7.99976 18.2798 7.99976 19.1198 7.99976 20.8V21M15.9998 3V3.2C15.9998 4.88016 15.9998 5.72024 16.3267 6.36197C16.6144 6.92646 17.0733 7.3854 17.6378 7.67302C18.2795 8 19.1196 8 20.7998 8H20.9998M15.9998 21V20.8C15.9998 19.1198 15.9998 18.2798 16.3267 17.638C16.6144 17.0735 17.0733 16.6146 17.6378 16.327C18.2795 16 19.1196 16 20.7998 16H20.9998"
                        stroke="#ffffff"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                )}

                <button
                  style={{ margin: '0' }}
                  className="close-btn"
                  onClick={handleCloseWithDraftCheck}
                >
                  <svg
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM8.96963 8.96965C9.26252 8.67676 9.73739 8.67676 10.0303 8.96965L12 10.9393L13.9696 8.96967C14.2625 8.67678 14.7374 8.67678 15.0303 8.96967C15.3232 9.26256 15.3232 9.73744 15.0303 10.0303L13.0606 12L15.0303 13.9696C15.3232 14.2625 15.3232 14.7374 15.0303 15.0303C14.7374 15.3232 14.2625 15.3232 13.9696 15.0303L12 13.0607L10.0303 15.0303C9.73742 15.3232 9.26254 15.3232 8.96965 15.0303C8.67676 14.7374 8.67676 14.2625 8.96965 13.9697L10.9393 12L8.96963 10.0303C8.67673 9.73742 8.67673 9.26254 8.96963 8.96965Z"
                      fill="#fff"
                    />
                  </svg>
                </button>
              </div>
            </div>
            {!isMinimized && (
              <div className="popup-body email_body">
                <Formik initialValues={formData} onSubmit={(values) => handleSubmit(values)}>
                  <Form>
                    <div className="container_label border_btm">
                      <div className="label_nm">
                        <div className="label_nm">
                          <span> From :</span>

                          <div className="label_content">
                            <div>
                              <CreatableSelect
                                isMulti={false}
                                name="fromAddress"
                                value={selectedFromEmail}
                                options={fromAddressOptions}
                                onChange={(selectedOption) =>
                                  handleEmailChange(selectedOption, 'fromAddress')
                                }
                                placeholder={
                                  formData.fromAddress ? formData.fromAddress : 'Select options...'
                                }
                                styles={{
                                  control: (base, state) => ({
                                    ...base,
                                    border: state.isFocused
                                      ? '2px solid transparent'
                                      : '1px solid transparent',
                                    borderRadius: '5px',
                                    boxShadow: state.isFocused ? 'none' : 'none',
                                    ':hover': {
                                      borderColor: 'transparent',
                                    },
                                  }),
                                  placeholder: (base) => ({
                                    ...base,
                                    color: '#888',
                                    fontSize: '.8rem',
                                  }),

                                  menu: (base) => ({
                                    ...base,
                                    minWidth: '250px',
                                    width: '250px',
                                  }),
                                  menuList: (base) => ({
                                    ...base,
                                    minWidth: '250px',
                                    width: '250px',
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    display: 'block', // Hide the dropdown arrow
                                  }),
                                  multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: '#E7F2FF',
                                    borderRadius: '50px',
                                    padding: '5px 14px',
                                  }),
                                  multiValueLabel: (base) => ({
                                    ...base,
                                    color: '#707070',
                                    fontSize: '.8rem',
                                  }),
                                  multiValueRemove: (base) => ({
                                    ...base,
                                    color: '#4caf50',
                                    ':hover': {
                                      backgroundColor: '#d32f2f',
                                      color: '#fff',
                                    },
                                  }),
                                }}
                                isDisabled={localData.type === 'preview'}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="heading_item" id="insert_template">
                        <button
                          className="btn action-btn"
                          type="button"
                          onClick={handleReset}
                          disabled={localData.type === 'preview'}
                        >
                          <img
                            src={reset}
                            alt="Reset Template"
                            className="me-2"
                            style={{ width: '12px', height: '12px' }}
                          />
                          <span className="btnText">Reset Template</span>
                        </button>
                        <button
                          className="btn action-btn"
                          type="button"
                          onClick={handleOpenTemplatePopup}
                          disabled={localData.type === 'preview'}
                        >
                          <img
                            src={template}
                            alt="Insert Template"
                            className="me-2"
                            style={{ width: '16px', height: '16px' }}
                          />
                          <span className="btnText">Insert Template</span>
                        </button>
                      </div>
                    </div>
                    <div className="container_label border_btm">
                      <div className="label_nm">
                        <span> To :</span>

                        <div className="label_content">
                          <div>
                            <CreatableSelect
                              isMulti={false}
                              name="toAddress"
                              value={selectedToEmails}
                              onChange={(selectedOptions) =>
                                handleEmailChange(selectedOptions, 'toAddress')
                              }
                              placeholder={
                                formData.toAddress ? formData.toAddress : 'Select options...'
                              }
                              styles={customStyles}
                              isDisabled={localData.type === 'preview'}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="label_nm">
                        {!showCcMail && localData.type !== 'preview' && (
                          <span
                            onClick={handleShowCc}
                            style={{ marginRight: '10px', width: 'auto' }}
                          >
                            Cc
                          </span>
                        )}
                        {!showBccMail && localData.type !== 'preview' && (
                          <span onClick={handleShowBcc} style={{ width: 'auto' }}>
                            Bcc
                          </span>
                        )}
                      </div>
                    </div>
                    {(showCcMail || (localData.ccAddress && localData.ccAddress.length > 0)) && (
                      <div className="container_label border_btm">
                        <div className="label_nm ">
                          <span> Cc :</span>

                          <div className="label_content">
                            <div>
                              <CreatableSelect
                                isMulti
                                name="ccAddress"
                                value={selectedCcEmail}
                                onChange={(selectedOptions) =>
                                  handleEmailChange(selectedOptions, 'ccAddress')
                                }
                                placeholder={
                                  formData.ccAddress ? formData.ccAddress : 'Select options...'
                                }
                                styles={customStyles}
                                isDisabled={localData.type === 'preview'}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {(showBccMail || (localData.bccAddress && localData.bccAddress.length > 0)) && (
                      <div className="container_label border_btm">
                        <div className="label_nm">
                          <span> Bcc :</span>

                          <div className="label_content">
                            <div>
                              <CreatableSelect
                                isMulti
                                name="bccAddress"
                                value={selectedBccEmail}
                                onChange={(selectedOptions) =>
                                  handleEmailChange(selectedOptions, 'bccAddress')
                                }
                                placeholder={
                                  formData.bccAddress ? formData.bccAddress : 'Select options...'
                                }
                                styles={customStyles}
                                isDisabled={localData.type === 'preview'}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="container_label border_btm" id="subjectfield">
                      <div className="label_nm">
                        <span>Subject :</span>

                        <div className="label_content">
                          <div>
                            <TextBox
                              name={'subject'}
                              value={formData.subject}
                              handleChange={handleChangeForm}
                              placeholder={formData.subject ? formData.subject : 'Subject'}
                              styles={customStyles}
                              disabled={localData.type === 'preview'}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div id="sendemail_area">
                      {formData.message && formData.message != null && !preview ? (
                        <div className="email_textarea" style={{ padding: '0' }}>
                          <Editor
                            name="message"
                            value={formData.message}
                            onChange={(e) =>
                              handleChangeForm({
                                target: { name: 'message', value: e.target.value },
                              })
                            }
                            style={{
                              padding: '10px 0px 10px 0px',
                              margin: '0',
                              overflowY: 'auto',
                              height: 'calc(100vh - 364px)',
                              border: '0',
                              borderRadius: ' 0px',
                            }}
                            handleChange={handleChangeForm}
                            disabled={localData.type === 'preview'}
                          />
                        </div>
                      ) : formData?.message?.includes('<!DOC') || preview ? (
                        <div className="email_textarea" style={{ padding: '0' }}>
                          <div
                            style={{
                              padding: '0px',
                              margin: '0',
                              overflowY: 'auto',
                              height: 'calc(100vh - 334px)',
                              border: '0',
                              borderRadius: ' 0px',
                            }}
                          >
                            <EmailEditor
                              ref={emailEditorRef}
                              onLoad={onLoad}
                              options={{
                                displayMode: 'email',
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <TextArea
                          name="message"
                          value={formData.message}
                          handleChange={handleChangeForm}
                        />
                      )}
                    </div>
                  </Form>
                </Formik>
              </div>
            )}
            {!isMinimized && (
              <div
                className="popup-footer"
                style={{
                  borderTop: '1px solid #ccc',
                  position: 'absolute',
                  bottom: '0px',
                  width: '100%',
                  background: '#fff',
                  filter: ' drop-shadow(0 8px 8px rgba(0, 0, 0, 0.1))',
                }}
              >
                <div className="email_group">
                  <OverlayTrigger
                    trigger="click"
                    placement="top"
                    rootClose={true}
                    show={popupVisible}
                    onToggle={() => setPopupVisible(!popupVisible)}
                    overlay={
                      <Popover id="popover-basic">
                        <Popover.Body>
                          <div
                            className="showcontent"
                            id="datetime"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <DateTimePicker
                              position="top"
                              value={scheduleTime}
                              onChange={(e) => setScheduleTime(e?.target?.value || '')}
                              name="scheduleTime"
                              placeholder="Select schedule time"
                              maxDays={2}
                            />
                          </div>

                          <div className="rightAction text-end">
                            <button
                              type="button"
                              className="btn btn-primary addBtn"
                              onClick={handleDone}
                            >
                              Done
                            </button>
                          </div>
                        </Popover.Body>
                      </Popover>
                    }
                  >
                    <div
                      className={`schedule-btn ${localData.type === 'preview' ? 'disabled' : ''}`}
                      type="button"
                      onClick={() => {
                        if (localData.type !== 'preview') setPopupVisible(!popupVisible);
                      }}
                    >
                      <img src={schedule} alt="schedule" className="me-2" />
                      Schedule
                    </div>
                  </OverlayTrigger>
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={handleSend}
                    disabled={isSendDisabled || localData.type === 'preview' || loading}
                  >
                    {loading && (
                      <>
                        {' '}
                        <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                      </>
                    )}
                    {loading ? 'Sending...' : 'Send'}
                  </button>
                </div>
              </div>
            )}
          </div>
          {templatePopup && (
            <SelectTemplate
              handleClose={handleCloseTemplatePopup}
              handleSubmit={handleHtml}
              module={module}
            />
          )}
        </div>
      </div>
      <div id="warningpopup">
        {showPopup && (
          <div className="popup-overlay">
            <div className="popup-content">
              <div className="warning-content">
                <div className="alertImg alertImgWaring">
                  <img src="../assets/images/alert.png" alt="Warning"></img>
                </div>
                <div className="warningText">
                  {' '}
                  <p>Are you sure you want to discard this?</p>
                </div>
                <div className="warningBtn">
                  <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={() => setShowPopup(false)} // Keep the form open
                  >
                    No
                  </button>
                  <button
                    type="button "
                    className="btn btn-primary"
                    onClick={handleClose} // Close the form
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default ComposeEmail;
